export enum Severity {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

export type TAssert = {
  (
    condition: boolean,
    err: Error,
    severity?: keyof typeof Severity
  ): asserts condition;
};

export type TLoggers = {
  error?: (msg: string) => void;
  warn?: (msg: string) => void;
  info?: (msg: string) => void;
};

export type TAttachLoggers = (loggers: TLoggers) => void;
export type TGetLoggers = () => TLoggers;

export type TLog = {
  (message: string, severity?: keyof typeof Severity): void;
};
